const ClearIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={7} height={7} fill="none">
      <path d="M0.75 5.75L5.75 0.75M0.75 0.75L5.75 5.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
};

export default ClearIcon;
